

import React, { useState } from 'react';

const IntroSection = ({ items = [], report_count,type  }) => {
  const [badgeHovered, setBadgeHovered] = useState(false);

  if (!items.length) return null;

  const {
    heading,
    subheading,
    description,
    button,
    button1,
    onButtonClick,
    onSecondButtonClick,
    image
  } = items[0];

  return (
    <div className="mx-auto w-full">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap');

        .intro-heading {
          font-family: 'Inter', sans-serif;
          font-weight: 700;
          font-size: 52px;
          line-height: 60px;
          color: var(--color-brand-primary);
          margin-bottom: 6px;
        }

        .intro-subheading {
          font-weight: 700;
          font-size: 30px;
          line-height: 50px;
          color: var(--color-brand-green);
        }

        .intro-desc {
          font-weight: 500;
          font-size: 16px;
          line-height: 1.6;
          color: var(--color-text-subheading);
          margin-bottom: 42px;
          max-width: 600px;
        }

        .btn-primary {
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
          background: var(--color-brand-primary);
          border: 1.5px solid var(--color-brand-primary);
          border-radius: 999px;
          padding: 12px 28px;
          cursor: pointer;
          transition: background 0.2s;
        }
        .btn-primary:hover { background: var(--color-brand-primary-hover); }

        .btn-outline-wrapper {
          display: inline-block;
          border-radius: 999px;
        }

        .btn-outline {
          font-weight: 600;
          font-size: 16px;
          color: var(--color-brand-primary);
          background: #ffffff;
          border: 1.5px solid var(--color-brand-primary);
          border-radius: 999px;
          padding: 12px 28px;
          cursor: pointer;
          transition: background 0.2s;
        }
        .btn-outline:hover { background: #EAF3FA; }

        /* BADGE */
       
          .reports-badge {
          min-width: clamp(120px, 14vw, 170px);
          background: #ffffff;
          border: 1px solid #80DAF1;
          border-radius: 8px;
          padding: 10px 16px;
          color: var(--color-brand-primary);

          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          text-align: left;

          /* 🔥 always glowing + floating */
          animation: glowPulse 3.5s ease-in-out infinite,
                     floatBadge 3.5s ease-in-out infinite;
        }

        .reports-badge:hover {
          transform: scale(1.08);
        }

        .badge-count {
          font-weight: 700;
          font-size: clamp(18px, 2.5vw, 28px);
          line-height: 1.1;
          color: var(--color-brand-green);
        }

        .badge-label {
          font-weight: 500;
          font-size: clamp(11px, 1.2vw, 16px);
          line-height: 1.25;
          margin-top: 2px;
        }

        /* ANIMATIONS */
        @keyframes glowPulse {
          0%, 100% {
            box-shadow: 0px 4px 10px 0px #80DAF180;
          }
          50% {
            box-shadow: 0px 4px 18px 2px #80DAF1;
          }
        }

        @keyframes floatBadge {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-6px);
  }
}

        /* LAYOUT */
        .intro-wrapper {
          background-color: #ffffff;
          background-image: var(--section-bg-gradient);
          display: flex;
          justify-content: space-between;
          padding: 20px max(64px, calc(50% - 656px));
          overflow: hidden;
        }

        .intro-left {
          max-width: 50%;
          display: flex;
          flex-direction: column;
          margin-top: 48px;
        }

        .intro-right {
          width: 48%;
          display: flex;
          justify-content: flex-end;
        }

        .intro-btns {
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
        }

        .intro-image-wrapper {
          position: relative;
          width: 100%;
        }

        .intro-image-container {
          width: 100%;
          height: 410px;
          padding-bottom: 50px;
          box-sizing: border-box;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        .intro-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transform: scale(1.15) translate(30px, 20px);
        }

        .badge-overlay {
          position: absolute;
          top: 10px;
          left: -30px;
          z-index: 2;
          
        }

        /* TABLET */
        @media (max-width: 1024px) {
          .intro-wrapper {
            padding: 30px;
          }

          .intro-left {
            max-width: 100%;
          }

          .intro-right {
            width: 100%;
          }

          .intro-image-container {
            height: 300px;
            padding-bottom: 20px;
          }

          .intro-image {
            transform: scale(1.1) translate(10px, 20px);
          }

          .badge-overlay {
            left: 0px;
            transform: scale(0.9);
          }
        }

        /* MOBILE */
        /* MOBILE */
@media (max-width: 768px) {
  .intro-wrapper {
    flex-direction: column;
    padding: 24px 20px;
  }

  .intro-left {
    align-items: center;
    text-align: center;
    margin-top: 0;
  }

  .intro-heading {
    font-size: 32px;
    line-height: 38px;
  }

  .intro-subheading {
    font-size: 20px;
    line-height: 28px;
  }

  .intro-desc {
    max-width: 100%;
  }

  .intro-right {
    width: 100%;
    margin-top: 20px;
  }

  .intro-image-container {
    height: 380px;
    padding-bottom: 0;
    justify-content: center;
  }

  .intro-image {
    transform: scale(1.15) translate(0px, 10px);
  }

  /* B. Reduced badge: smaller scale + repositioned */
  .badge-overlay {
    top: 8px;
    left: 8px;
    transform: scale(0.65);
    transform-origin: top left;
  }
}

        /* SMALL MOBILE */
        /* SMALL MOBILE */
@media (max-width: 480px) {
  .intro-heading {
    font-size: 26px;
    line-height: 32px;
  }

  .intro-subheading {
    font-size: 16px;
  }

  .intro-image-container {
    height: 320px;
    padding-bottom: 0;
  }

  .intro-image {
    transform: scale(1.05) translate(0px, 5px);
  }

  /* B. Even smaller badge on tiny screens */
  .badge-overlay {
    transform: scale(0.55);
    transform-origin: top left;
  }
}
      `}</style>

      <div className="intro-wrapper">

        {/* LEFT */}
        <div className="intro-left">
          <h1 className="intro-heading">{heading}</h1>
          <p className="intro-subheading">{subheading}</p>
          <p className="intro-desc">{description}</p>

          <div className="intro-btns">
            {button && (
              <button className="btn-primary" onClick={onButtonClick}>
                {button}
              </button>
            )}

            {button1 && (
              <span className="btn-outline-wrapper">
                <button className="btn-outline" onClick={onSecondButtonClick}>
                  {button1}
                </button>
              </span>
            )}
          </div>
        </div>

        {/* RIGHT */}
        <div className="intro-right">
          <div className="intro-image-wrapper">

            {image && (
              <div className="intro-image-container">
                <img src={image} alt={heading} className="intro-image" />
              </div>
            )}

            {report_count !== undefined && (
              <div className="reports-badge badge-overlay">
                <div className="badge-count">{report_count}</div>
               <div className="badge-label">
  {type === "triage" ? "Triages Done" : "Reports Generated"}
</div>
              </div>
            )}

          </div>
        </div>

      </div>
    </div>
  );
};

export default IntroSection;